
export const deviceCategories = [
  'car',
  'truck',
  'motorcycle',
  'tractor',
  'bus',
  'pickup',
  'van',
  'ambulance',
  'threeWheeler',
  'eRickshaw',
  'jcb',
  'crane',
  'mixerTruck',
  'person',
  'arrow',
  'default',
  'bicycle',
  'animal',
  'boat',
  'helicopter',
  'offroad',
  'plane',
  'ship',
];
